import { DefaultRequest } from 'scripts/api';

Monet.Ajax = DefaultRequest;

Monet.Ajax.downloadCSV = (fileName, url, method, criteria) => {
  return new Promise((resolve, reject) => {
    const request = new Monet.Ajax();
    request.method = method;
    request.isFile = true;
    request.url = url;
    if (method === 'post' && criteria) {
      request.data = criteria;
    }
    request.success = (data) => {
      const isInternetExplorer = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.userAgent.indexOf('Trident') !== -1;
      const link = document.createElement('a');

      document.body.appendChild(link);

      if (isInternetExplorer) {
        if (navigator.userAgent.indexOf('MSIE 9.0') > 0) {
          const newBrowserWindow = window.open('about:blank', '_blank', 'noopener,noreferrer');
          newBrowserWindow.document.write(data);
          newBrowserWindow.document.close();
          newBrowserWindow.document.execCommand('SaveAs', true, fileName);
          newBrowserWindow.close();
          document.body.removeChild(link);
          resolve();
        } else {
          link.addEventListener('click', () => {
            navigator.msSaveBlob(data, fileName);
            document.body.removeChild(link);
            resolve();
          }, false);
        }
      } else {
        link.href = URL.createObjectURL(data);
        link.download = fileName;
        document.body.removeChild(link);
        resolve();
      }

      link.click();
    };

    request.error = (xhr) => {
      reject(xhr);
      Monet.Configurations.errorNotification(null, xhr, null, null);
    };

    request.send();
  });
};
